import gql from 'graphql-tag';

import {
  EventAddonItemDetails,
  EventItemFeaturesDetails,
  PurchasedEventItemFeaturesDetails,
} from '../fragments/events';

export const EventItems = gql`
  query eventItems {
    eventItems(platform: WEB, include_weddings_free_plan: true) {
      id
      album_subtype
      album_type
      app_store_id
      price {
        value
        currency
      }
      video_guestbook_enabled
      free_waldograms_count
      plan
      name
      ...EventItemFeaturesDetails
    }
  }
  ${EventItemFeaturesDetails}
`;

export const MeForPurchasedEvents = gql`
  query meForPurchasedEvents(
    $album_type: AlbumTypesType
    $album_subtype: AlbumSubtypesType
    $unassigned_only: Boolean = true
    $assigned_only: Boolean = false
    $purchased_event_id: RecordID
    $album_folder_id: RecordID
    $limit: Int = 999
    $offset: Int = 0
  ) {
    me {
      id
      roles
      purchased_events(
        album_type: $album_type
        album_subtype: $album_subtype
        unassigned_only: $unassigned_only
        assigned_only: $assigned_only
        purchased_event_id: $purchased_event_id
        album_folder_id: $album_folder_id
        slice: { limit: $limit, offset: $offset }
      ) {
        records {
          id
          album_type
          album_subtype
          album_folder {
            id
            purchased_event {
              id
              for_gift
              plan
              ...PurchasedEventItemFeaturesDetails
            }
          }
          for_gift
          config_url
          free_waldograms_count
          video_guestbook_enabled
          plan
          name
          ...PurchasedEventItemFeaturesDetails
        }
        total
      }
    }
  }
  ${PurchasedEventItemFeaturesDetails}
`;

export const EventAddonItems = gql`
  query eventAddonItems(
    $hierarchy_item_id: RecordID
    $event_addon_item_id: String
    $enable_photo_finder_event_addon_items: Boolean
    $include_event_addon_bundles: Boolean
    $platform: AppPlatformEnum = WEB
  ) {
    eventAddonItems(
      platform: $platform
      hierarchy_item_id: $hierarchy_item_id
      event_addon_item_id: $event_addon_item_id
      include_event_addon_bundles: $include_event_addon_bundles
      enable_photo_finder_event_addon_items: $enable_photo_finder_event_addon_items
    ) {
      id
      ...EventAddonItemDetails
    }
  }
  ${EventAddonItemDetails}
`;

export const AlbumFolderWithPurchasedEventAddons = gql`
  query albumFolderWithPurchasedEventAddons($id: RecordID!) {
    albumFolder(id: $id) {
      id
      purchased_event_addons {
        records {
          id
          event_addon_type
          album {
            id
            name
            album_type
            album_subtype
            album_folder {
              id
            }
          }
        }
      }
    }
  }
`;
